// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe, enumOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsDirectCdiJobsJobIdSinkLogsRequestExportResult = objectOf({
  result: enumOf("success", "error"),
  response_code: maybe(number),
  message: maybe(string),
  requester_email: maybe(string),
});
